import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import Loader from "../../../components/Loader/Loader";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import PDF from "../../../assets/images/pdf.svg";
import "../../../components/common/css/campaignview.scss";

const InventmeView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const campaignView = useSelector((state) => state.campaignView);
  const navigate = useNavigate();

  const id = useParams();

  let token = localStorage.getItem("accessToken");
  const d = new Date(data?.createdAt);

  const ApproveArticle = () => {
    setLoading(true);

    axios
      .post(
        process.env.REACT_APP_API +
          `admin/invent-me/article/${+id.articleId}/publish`,
        {},
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then(function (response) {
        if (response?.data?.status == 200) {
          Swal.fire({
            title: "Success",
            timer: 2500,
            timerProgressBar: true,
            text: response?.data?.message,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/inventme");
        }

        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const RejectArticle = () => {
    setLoading(true);

    axios
      .post(
        process.env.REACT_APP_API +
          `admin/invent-me/article/${+id.articleId}/unpublish`,
        {},
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then(function (response) {
        if (response?.data?.status == 200) {
          Swal.fire({
            title: "Success",
            timer: 2500,
            timerProgressBar: true,
            text: response?.data?.message,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/inventme");
        }

        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  useEffect(() => {
    ArticleById();
  }, []);

  const ArticleById = () => {
    setLoading(true);

    axios
      .get(process.env.REACT_APP_API + `invent-me/article/${+id.articleId}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then(function (response) {
        setData(response.data.data);
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="top">
          <div className="left">
            <h1 className="title">User Information</h1>
            <div className="item">
              <img
                src={
                  data?.user?.profilePic == null
                    ? ProfilePic
                    : data?.user?.profilePic
                }
                alt=""
                className="itemImg"
              />
              <div className="details profile-info first">
                {/* <h1 className="itemTitle">
                      {userInfo.user.firstname} {userInfo.user.lastname}
                    </h1> */}
                <div className="detailItem">
                  <span className="itemKey">Name:</span>
                  <span className="itemValue">
                    <b>
                      {data?.user?.firstname} {data?.user?.lastname}{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </b>
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Email:</span>
                  <span className="itemValue">
                    {data?.user?.email == null ? "" : data?.user?.email}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="left">
            {/* <div className="editButton">Edit</div> */}
            <h1 className="title">Article Information</h1>
            <div className="item">
              <div className="details profile-info article-info">
                <div className="detailItem">
                  <span className="itemKey">Tittle:</span>
                  <span className="itemValue">{data?.title}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">SubTitle:</span>
                  <span className="itemValue">{data?.subtitle}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Category:</span>
                  <span className="itemValue">
                    {data?.article_category?.category_name}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Location:</span>
                  <span className="itemValue">{data?.projectLocation}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Project Format:</span>
                  <span className="itemValue">{data?.projectFormat}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">ESG Project:</span>
                  <span className="itemValue">{data?.esg}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Project Stage:</span>
                  <span className="itemValue">{data?.projectStage}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Tender Submission By:</span>
                  <span className="itemValue">{data?.tenderSubmissionBy}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Target Completed By:</span>
                  <span className="itemValue">{data?.targetCompletionBy}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Article CreatedAt:</span>
                  <span className="itemValue">
                    {d?.getHours() +
                      ":" +
                      d?.getMinutes() +
                      ":" +
                      d?.getSeconds() +
                      ", " +
                      d?.toDateString()}
                  </span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Likes:&nbsp;&nbsp;&nbsp;</span>
                  <span className="itemValue">{data?.likeCounter}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">DisLikes:&nbsp;&nbsp;&nbsp;</span>
                  <span className="itemValue">{data?.disLikeCounter}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Views:&nbsp;&nbsp;&nbsp;</span>
                  <span className="itemValue">{data?.viewCounter}</span>
                </div>

                {/* <br /> */}
                <div className="idDocs">
                  <span className="itemKey">
                    Description:&nbsp;&nbsp;&nbsp;
                  </span>
                  <div
                    className="itemValue articleDesc"
                    dangerouslySetInnerHTML={{
                      __html: data?.description,
                    }}
                  ></div>
                </div>
                <div className="idDocs">
                  <span className="itemKey">
                    Feature Image:&nbsp;&nbsp;&nbsp;
                  </span>
                  <div className="itemValue">
                    <a
                      href={data?.article_medium?.fileURL}
                      target="_blank"
                      className="docLink"
                    >
                      {data?.article_medium?.fileURL !== null && (
                        <img
                          src={data?.article_medium?.fileURL}
                          className="docImage"
                        />
                      )}
                      {/* {data?.article_medium?.fileURL !== null && (
                        <p className="docName">doc {i + 1}</p>
                      )} */}
                    </a>
                  </div>
                </div>
                <div className="idDocs">
                  <span className="itemKey">
                    Attachments:&nbsp;&nbsp;&nbsp;
                  </span>
                  <div className="itemValue">
                    {data?.attachments?.length > 0 ? (
                      data.attachments.map((file, index) => (
                        <a
                          key={file.id || index}
                          href={file.fileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="docLink"
                        >
                          <img src={PDF} alt="PDF File" className="docImage" />
                          <span className="fileName">
                            {file.originalFileName}
                          </span>
                        </a>
                      ))
                    ) : (
                      <span>No PDF Available</span>
                    )}
                  </div>
                </div>

                <div className="idDocs">
                  <span className="itemKey"> Video URL:&nbsp;&nbsp;&nbsp;</span>
                  <div className="itemValue">
                    <a
                      href={data?.article_medium?.videoURL}
                      target="_blank"
                      className="docLink"
                    >
                      {data?.article_medium?.videoURL}
                      {/* {data?.article_medium?.fileURL !== null && (
                        <p className="docName">doc {i + 1}</p>
                      )} */}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="left">
            <h1 className="title">Project Sector Information</h1>
            <div className="item">
              <div className="details profile-info">
                {/* Main Project Sector */}
                <div className="detailItem">
                  <span className="itemKey">Main Project Sector:</span>
                  <div className="itemValue">
                    {data?.mainProjectSector &&
                    data.mainProjectSector.length > 0 ? (
                      <div className="sector-tags">
                        {data.mainProjectSector.map((sector, index) => (
                          <span key={index} className="sector-tag main-sector">
                            {sector}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span>No main sector specified</span>
                    )}
                  </div>
                </div>

                {/* Agriculture, Food and Rural Development */}
                {data?.agricultureFoodRuralDevelopment &&
                  data.agricultureFoodRuralDevelopment.length > 0 && (
                    <div className="detailItem">
                      <span className="itemKey">
                        Agriculture, Food and Rural Development:
                      </span>
                      <div className="itemValue">
                        <div className="sector-tags">
                          {data.agricultureFoodRuralDevelopment.map(
                            (subcategory, index) => (
                              <span
                                key={index}
                                className="sector-tag sub-sector"
                              >
                                {subcategory}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                {/* Energy and Natural Resources */}
                {data?.energyNaturalResources &&
                  data.energyNaturalResources.length > 0 && (
                    <div className="detailItem">
                      <span className="itemKey">
                        Energy and Natural Resources:
                      </span>
                      <div className="itemValue">
                        <div className="sector-tags">
                          {data.energyNaturalResources.map(
                            (subcategory, index) => (
                              <span
                                key={index}
                                className="sector-tag sub-sector"
                              >
                                {subcategory}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                {/* Public Utilities */}
                {data?.publicUtilities && data.publicUtilities.length > 0 && (
                  <div className="detailItem">
                    <span className="itemKey">Public Utilities:</span>
                    <div className="itemValue">
                      <div className="sector-tags">
                        {data.publicUtilities.map((subcategory, index) => (
                          <span key={index} className="sector-tag sub-sector">
                            {subcategory}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Technology */}
                {data?.technology && data.technology.length > 0 && (
                  <div className="detailItem">
                    <span className="itemKey">Technology:</span>
                    <div className="itemValue">
                      <div className="sector-tags">
                        {data.technology.map((subcategory, index) => (
                          <span key={index} className="sector-tag sub-sector">
                            {subcategory}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Transport and Logistics */}
                {data?.transportLogistics &&
                  data.transportLogistics.length > 0 && (
                    <div className="detailItem">
                      <span className="itemKey">
                        Transport and Logistics Infrastructure:
                      </span>
                      <div className="itemValue">
                        <div className="sector-tags">
                          {data.transportLogistics.map((subcategory, index) => (
                            <span key={index} className="sector-tag sub-sector">
                              {subcategory}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                {/* Urban Development */}
                {data?.urbanDevelopment && data.urbanDevelopment.length > 0 && (
                  <div className="detailItem">
                    <span className="itemKey">Urban Development:</span>
                    <div className="itemValue">
                      <div className="sector-tags">
                        {data.urbanDevelopment.map((subcategory, index) => (
                          <span key={index} className="sector-tag sub-sector">
                            {subcategory}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="left">
            {data?.status == 1 || data?.status == 4 ? (
              <div>
                <h1 className="title">
                  You can click on Approve / Reject button below to respond.
                </h1>
                <div className="item">
                  <div className="details profile-info">
                    <div className="submitButton">
                      <Button
                        variant="contained"
                        className="approveButton"
                        onClick={ApproveArticle}
                      >
                        Approve
                      </Button>
                      <Button
                        variant="contained"
                        className="declineButton"
                        onClick={RejectArticle}
                      >
                        Reject
                      </Button>
                    </div>
                  </div>
                </div>{" "}
              </div>
            ) : (
              ""
            )}
            {data?.status == 2 ? (
              <span className="article-note-msg">
                <b>Note</b>: This article is already publish.{" "}
              </span>
            ) : (
              ""
            )}
            {data?.status == 3 ? (
              <span className="file-note-msg">
                <b>Note</b>: This article is already rejected.{" "}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventmeView;
